const en = {
  today: "Today's Matches",
  live: "LIVE",
  upcoming: "Upcoming",
  stats: "Match Stats",
  noLive: "No live matches right now",
  clickForStats: "Click for full stats",
  viewOdds: "View Live Odds →",
  headToHead: "Head to Head",
  form: "Current Form",
  goalStats: "Goal Stats",
  leagueTable: "League Table",
  injuries: "Injuries & Suspensions",
  outcome: "Probable Outcome",
  homeWin: "Home Win",
  draw: "Draw",
  awayWin: "Away Win",
  confidence: "Confidence",
  viewing: "people viewing",
  subscribe: "Get Weekly Insights Free",
  subscribeDesc: "Every Friday — Top 5 matches with stats. No spam.",
  yourEmail: "Your email address",
  subscribe_btn: "Subscribe Free",
  worldCup: "FIFA World Cup 2026",
  daysAway: "days away",
  viewQualifiers: "View Qualifiers",
  featuredMatches: "🔥 Big Matches Coming Up",
  favourite: "Favourite Teams",
  addFav: "Add to favourites",
  removeFav: "Remove from favourites",
  kickoff: "Kick-off",
  stadium: "Venue",
  season: "Season Preview",
  loading: "Loading matches...",
  avgScored: "Avg Scored",
  avgConceded: "Avg Conceded",
};
export default en;